export default __webpack_public_path__ + "static/media/multi-collateral-dai-dai-logo.1096719c.svg";